import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminInfoComponent } from './admin/admin-info/admin-info.component';
import { AdminMainComponent } from './admin/admin-main/admin-main.component';
import { AdminComponent } from './admin/admin.component';
import { AdminNoticeEditComponent } from './admin/notice/admin-notice/admin-notice-edit/admin-notice-edit.component';
import { AdminNoticeComponent } from './admin/notice/admin-notice/admin-notice.component';
import { AdminRecruitEditComponent } from './admin/recruit/admin-recruit-edit/admin-recruit-edit.component';
import { AdminRecruitComponent } from './admin/recruit/admin-recruit/admin-recruit.component';
import { CompanyComponent } from './home/company/company.component';
import { LocationComponent } from './home/company/location/location.component';
import { TechnologyComponent } from './home/company/technology/technology.component';
import { VisionComponent } from './home/company/vision/vision.component';
import { HomeComponent } from './home/home.component';
import { MainComponent } from './home/main/main.component';
import { NewsComponent } from './home/news/news.component';
import { ProductComponent } from './home/product/product.component';
import { RecruitDetailComponent } from './home/recruit/recruit-detail/recruit-detail.component';
import { RecruitComponent } from './home/recruit/recruit.component';

const routes: Routes = [
  {path:'', component:HomeComponent, 
    children: [
      {path:'', component:MainComponent, pathMatch: 'full'},
      {path:'company/:data', component:CompanyComponent, pathMatch:'prefix'},
      {path:'product/:data', component:ProductComponent, pathMatch:'full'},
      {path:'recruit/:data', component:RecruitComponent, pathMatch:'full'},
      {path:'news/:data', component:NewsComponent, pathMatch:'full'},
      {path:'recruitDetail', component:RecruitDetailComponent,pathMatch:'full'}
    ]
  },
  {path:'admin',component:AdminComponent,
    children: [
      {path:'',component:AdminMainComponent,pathMatch: 'full'},
      {path:'recruit',component:AdminRecruitComponent,pathMatch: 'full'},
      {path:'recruitEdit', component:AdminRecruitEditComponent, pathMatch: 'full'},
      {path:'notice', component:AdminNoticeComponent,pathMatch:'full'},
      {path:'noticeEdit', component:AdminNoticeEditComponent,pathMatch:'full'},
      {path:'adminInfo', component:AdminInfoComponent,pathMatch:'full'}
    ]
  }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
